import React, { useMemo } from "react";
import { useHistory, useParams } from "react-router-dom";
import { useTrans } from "system/translations/hooks";
import Card from "components/atoms/Card";
import FormBuilder from "services/formBuilder/FormBuilder";
import {
  useGetAssignmentRule,
  useUpdateAssignmentRules,
} from "modules/assignmentRules/apiHooks";
import { createEditValidation } from "modules/assignmentRules/validation";
import Loader from "components/atoms/Loader";
import { useCreateEditConfig } from "modules/assignmentRules/constantHooks";
import SectionTitle from "components/atoms/SectionTitle";
import { DeleteIcon } from "evergreen-ui";
import Btn from "components/atoms/Btn";

const Update: React.FC = () => {
  const isEdit = true;
  const { _t } = useTrans();
  const history = useHistory();
  const routeParams: any = useParams();
  const { data: assignmentRulesData = {}, isLoading } = useGetAssignmentRule(
    routeParams.id
  );
  const { mutateAsync: onUpdate } = useUpdateAssignmentRules();
  const formConfig = useCreateEditConfig({
    isEdit: true,
  });
  const onSubmit = async (data: any) => {
    const { key, ...rest } = data;
    await onUpdate({ data: rest, id: key });
    history.goBack();
  };

  if (isLoading) {
    return <Loader formOverlay />;
  }

  return (
    <>
      <SectionTitle
        title={_t("edit_country")}
        extra={
          <Btn
            kind={"default"}
            iconBefore={DeleteIcon}
            onClick={() => alert("in progress")}
          >
            {_t("delete_role")}
          </Btn>
        }
      />
      <Card title={_t("edit_translation")}>
        <FormBuilder
          formItemsConfig={formConfig}
          showSubmit={false}
          formProps={{
            onSubmit: onSubmit,
            initialValues: { ...assignmentRulesData },
            validationSchema: createEditValidation(_t, {
              isEdit,
            }),
          }}
        />
      </Card>
    </>
  );
};

export default Update;
